import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import booleanHelper from '../Helpers/booleanHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import moneyHelper from '../Helpers/moneyHelper';
import FeeTypesEnum from '../Enums/FeeTypesEnum';
import FreelancerUserAdmin from '../Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserAdmin';
import Link from '../Elements/link';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import GeneralEntryLogFigma from '../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../Elements/CommentsEntryLogDescription';
import FaIcon from '../Elements/FaIcon';
import LogComponent from '../Elements/LogComponent';
import FpaAdmin from '../Contents/FreelancerInvoicing/FreelancerPayableAssignments/FpaAdmin';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FreelancerFeeHelper from '../Helpers/ModelHelpers/FreelancerFeeHelper';

export default class FreelancerFeeItem {
  constructor(item) {
    if (item === undefined) {
      this.FreelancerFeeId = '';
      this.FreelancerUserId = '';
      this.FeeType = '';
      this.ClientId = '';
      this.SurveyId = '';
      this.SurveyName = '';
      this.SurveySassieId = '';
      this.SurveyTypeCallsEmails = false;
      this.SurveyType = '';
      this.TpSurveyId = '';
      this.TpSurveyThirdPartySurveyName = '';
      this.TpSurveyThirdPartySurveyId = '';
      this.TpSurveyTypeCallsEmails = false;
      this.ThirdPartySource = '';
      this.WaveId = '';
      this.WaveName = '';
      this.WaveSassieId = '';
      this.TpWaveId = '';
      this.TpWaveThirdPartyWaveName = '';
      this.TpWaveThirdPartyWaveId = '';
      this.CountryId = '';
      this.StartDate = new Date();
      this.EndDate = dateTimeHelper.indefiniteDateValue();
      this.Fee = '0';
      this.OptFee = '-1';
      this.SelfAssigned = false;
      this.Tier = 'tier1';
      this.FreelancerUserCurrencyCode = '';
      this.TimebasedSettlementEnabled = false;
      this.FreelancerUserTimebasedSettlementEnabled = false;

      this.CountryName = '';
      this.FreelancerUserName = '';
      this.ClientName = '';
      this.FeeWithCurrency = '';
      this.OptFeeWithCurrency = '';
      this.FreelancerUserUserType = '';
      this.NumberOfAttachedAssignments = 0;
      this.ClientSassied = '';
      this.ThirdPartyClientId = '';
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.FreelancerFeeId = item.freelancerFeeId;
    this.FreelancerUserId = item.freelancerUserId;
    this.FeeType = item.feeType;
    this.ClientId = item.clientId;
    this.SurveyId = item.surveyId;
    this.SurveyName = item.surveyName;
    this.SurveySassieId = item.surveySassieId;
    this.SurveyTypeCallsEmails =
      item.tpSurveySurveyType ?? item.surveySurveyType
        ? (item.tpSurveySurveyType ?? item.surveySurveyType) === 'CallsEmails'
        : item.surveyTypeCallsEmails;
    this.SurveyType = item.tpSurveySurveyType ?? item.surveySurveyType;
    this.TpSurveyId = item.tpSurveyId;
    this.TpSurveyThirdPartySurveyName = item.tpSurveyThirdPartySurveyName;
    this.TpSurveyThirdPartySurveyId = item.tpSurveyThirdPartySurveyId;
    this.ThirdPartySource = item.thirdPartySource;
    this.WaveId = item.waveId;
    this.WaveName = item.waveName;
    this.WaveSassieId = item.waveSassieId;
    this.TpWaveId = item.tpWaveId;
    this.TpWaveThirdPartyWaveName = item.tpWaveThirdPartyWaveName;
    this.TpWaveThirdPartyWaveId = item.tpWaveThirdPartyWaveId;
    this.CountryId = item.countryId;
    this.StartDate = new Date(Date.parse(item.startDate)); //.toLocaleDateString();
    this.EndDate = new Date(Date.parse(item.endDate)); //.toLocaleDateString();
    this.Fee = item.fee;
    this.OptFee = item.optFee === null ? -1 : item.optFee;
    this.SelfAssigned = item.selfAssigned;
    this.Tier = item.tier;
    this.FreelancerUserCurrencyCode = item.freelancerUserCurrencyCode;
    this.TimebasedSettlementEnabled = item.timebasedSettlementEnabled;
    this.FreelancerUserTimebasedSettlementEnabled = item.freelancerUserTimebasedSettlementEnabled;

    this.CountryName = item.countryName;
    this.FreelancerUserName = item.freelancerUserName;
    this.ClientName = item.clientName;
    this.ClientSassied = item.clientSassied;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.FreelancerUserUserType = item.freelancerUserUserType;
    this.NumberOfAttachedAssignments = item.numberOfAttachedAssignments;
  }

  static NameOfTheIdField() {
    return 'FreelancerFeeId';
  }
  static nameOfTheItemDetailList() {
    return 'Vendor Fees';
  }

  static MoneyFields = ['Fee'];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = ['OptFee'];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['StartDate', 'EndDate'];

  static BoolFields = ['SelfAssigned', 'SurveyTypeCallsEmails'];

  static Status(item, icon) {
    return item === true ? (
      <span className={`${icon} text-green`}> Yes</span>
    ) : (
      <span className={`${icon} text-red`}> No</span>
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'FeeType', label: 'Fee Type', className: 'text-left' },
        { name: 'StartDate', label: 'Start Date', className: 'text-center' },
        { name: 'EndDate', label: 'End Date', className: 'text-center' },
        {
          name: (item) => FreelancerFeeItem.Status(item.TimebasedSettlementEnabled, 'fa-solid fa-history'),
          label: 'Time Based',
          className: 'text-left',
        },
        {
          name: (item) => FreelancerFeeItem.Status(item.SurveyTypeCallsEmails, 'fa-solid fa-at'),
          label: 'Survey Type Calls/Emails',
          className: 'text-left',
        },
        {
          name: (item) => FreelancerFeeItem.Status(item.SelfAssigned, 'fa-solid fa-portrait'),
          label: 'Self Assigned',
          className: 'text-left',
        },
        { name: FreelancerFeeItem.getClientName, label: 'Client (Bravo ID)', className: 'text-left' },
        { name: FreelancerFeeItem.getSurveyName, label: 'Survey (ID)', className: 'text-left' },
        { name: FreelancerFeeItem.getWave, label: 'Wave (ID)', className: 'text-left' },
        { name: FreelancerFeeItem.getTpSurveyName, label: 'TpSurvey (ID)', className: 'text-left' },
        // { name: FreelancerFeeItem.getTpWave, label: 'TpWave (ID)', className: 'text-left' },
        { name: 'ThirdPartySource', label: 'Third Party Source', className: 'text-left' },
        { name: 'CountryName', label: 'Country Name', className: 'text-left' },
        { name: FreelancerFeeItem.getTierContent, label: 'Tier', className: 'text-left' },
        {},
        {
          name: (item) => moneyHelper.toMoneyFormat(item.Fee, item.FreelancerUserCurrencyCode),
          label: 'Fee',
          className: 'text-right',
        },
        {
          name: (item) =>
            item.OptFee < 0 ? '' : moneyHelper.toMoneyFormat(item.OptFee, item.FreelancerUserCurrencyCode),
          label: 'OptFee',
          className: 'text-right',
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      data: [
        { name: FreelancerFeeItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: FreelancerFeeItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  static getTierContent(item) {
    const t = FreelancerFeeItem.getTierSelectOptions().find((t) => t.value === item.Tier);
    return t === undefined ? '-' : t.label;
  }

  static getCommentsContent(item) {
    return (
      <GeneralEntryLogFigma
        description={CommentsEntryLogDescription}
        context={{ entityTypeId: 10006, entityId: item.FreelancerFeeId }}
      />
    );
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='FreelancerFee'
        entityId={item.FreelancerFeeId}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Id',
        orderById: 'FreelancerFeeId',
        data: 'FreelancerFeeId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 40,
      },
      {
        label: 'Vendor name (ID)',
        orderById: 'FreelancerUserName',
        data: FreelancerFeeItem.getFreelancerNameCellContent,
        minWidth: 150,
      },
      { label: 'Client (Bravo ID)', orderById: 'ClientName', data: FreelancerFeeItem.getClientName },
      { label: 'Survey (ID)', orderById: 'SurveyName', data: FreelancerFeeItem.getSurveyName },
      { label: 'TpSurvey (ID)', orderById: 'TpSurveyName', data: FreelancerFeeItem.getTpSurveyName },
      { label: 'Third Party Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource' },
      { label: 'Country', orderById: 'CountryName', data: 'CountryName' },
      { label: 'Date', orderById: 'StartDate', data: FreelancerFeeItem.generateDateFieldContent, minWidth: 150 },
      {
        label: 'Fee',
        orderById: 'Fee',
        data: (item) => moneyHelper.toMoneyFormat(item.Fee, item.FreelancerUserCurrencyCode),
        minWidth: 20,
      },
      {
        label: 'Opt fee',
        orderById: 'OptFee',
        data: (item) =>
          item.OptFee < 0 ? '' : moneyHelper.toMoneyFormat(item.OptFee, item.FreelancerUserCurrencyCode),
        minWidth: 20,
      },
      { label: 'Info', orderById: 'FreelancerFeeId', data: FreelancerFeeItem.getAdditionalInformation, minWidth: 40 },
      { label: ' ', orderById: ' ', data: ' ' },
      {
        label: ' ',
        orderById: '',
        data: FreelancerFeeItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 40,
        rolekey: 'freelancerdatatable_action',
      },
    ];
  }

  static getAdditionalInformation(item) {
    return (
      <div
        className={
          item.FeeType === FeeTypesEnum.Resource
            ? 'text-center text-success'
            : item.FeeType === FeeTypesEnum.DataQuality
            ? 'text-center text-danger'
            : 'text-center text-primary'
        }
      >
        <FaIcon
          className='infoButton'
          iconName={FreelancerFeeHelper.GetFeeTypeIcon(item.FeeType)}
          tooltipText={item.FeeType}
        />
        {item.SelfAssigned === true ? (
          <FaIcon
            iconName='fa-solid fa-portrait text-green'
            tooltipText='Self Assigned'
            className='infoButton'
          />
        ) : (
          ''
        )}
        {item.SurveyTypeCallsEmails === true ? (
          <FaIcon
            iconName='fa-solid fa-at text-green'
            tooltipText='Calls/Emails'
            className='infoButton'
          />
        ) : (
          ''
        )}
        {item.TimebasedSettlementEnabled === true ? (
          <FaIcon
            iconName='fa-solid fa-history text-green'
            tooltipText='Time-Based'
          />
        ) : (
          ''
        )}
        {/* <Link
						tooltipText={`Payable Assigments (${item.NumberOfAttachedAssignments})`}
						title="Payable Assignments"
						link={<FpaAdmin freelancerFeeId={item.FreelancerFeeId} />}
						className="link"
						iconName="fa-solid fa-socks"
						withoutText={true}
						disabled={item.NumberOfAttachedAssignments === 0}
					/> */}{' '}
      </div>
    );
  }

  static getClientName(item) {
    return `${item.ClientName} (${item.ClientId})`;
  }

  static getSurveyName(item) {
    if (item.SurveySassieId === '' || item.SurveySassieId === null) return item.SurveyName;

    return `${item.SurveyName} (${item.SurveySassieId})`;
  }

  static getTpSurveyName(item) {
    if (item.TpSurveyThirdPartySurveyId === '' || item.TpSurveyThirdPartySurveyId === null)
      return item.TpSurveyThirdPartySurveyName;

    return `${item.TpSurveyThirdPartySurveyName} (${item.TpSurveyThirdPartySurveyId})`;
  }

  static getWave(item) {
    if (item.WaveSassieId === '' || item.WaveSassieId === null) return item.WaveName;

    return `${item.WaveName} (${item.WaveSassieId})`;
  }

  static getTpWave(item) {
    if (item.TpWaveThirdPartyWaveId === '' || item.TpWaveThirdPartyWaveId === null)
      return item.TpWaveThirdPartyWaveName;

    return `${item.TpWaveThirdPartyWaveName} (${item.TpWaveThirdPartyWaveId})`;
  }

  static applyFeeForVendorFunction = (item) => {
    return null;
  };

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            title: `Vendor - Payable Assigments`,
            link: <FpaAdmin freelancerFeeId={item.FreelancerFeeId} />,
            iconName: 'fa-solid fa-socks',
            text: `Payable Assigments (${item.NumberOfAttachedAssignments})`,
            url: `freelancer_listassignments/search?InvoicingStatus=&FreelancerFeeId=${item.FreelancerFeeId}`,
          },
          {
            separator: true,
          },
          {
            iconName: 'fa-solid fa-pump-soap',
            text: 'Apply for Vendors',
            disabled: item.FreelancerUserUserType !== 'Agency',
            onClick: () => FreelancerFeeItem.applyFeeForVendorFunction(item),
          },
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            disabled: item.NumberOfAttachedAssignments !== 0,
            onClick: () => FreelancerFeeItem.editFunction(item.FreelancerFeeId, item),
          },
          {
            iconName: 'fa-regular fa-stop-circle',
            text: 'Close',
            // disabled:item.NumberOfAttachedAssignments!==0,
            onClick: () => FreelancerFeeItem.closeFunction(item.FreelancerFeeId, item),
          },
          {
            iconName: 'fa-regular fa-clone',
            text: 'Clone this fee',
            // disabled:item.NumberOfAttachedAssignments!==0,
            onClick: () => FreelancerFeeItem.cloneThisFeeFunction(item.FreelancerFeeId, item),
          },
        ]}
      />
    );
  }

  static getFreelancerNameCellContent(item) {
    return (
      <Link
        linktext={`${item.FreelancerUserName} (${item.FreelancerUserId})`}
        title='Vendors'
        link={<FreelancerUserAdmin freelancerUserId={item.FreelancerUserId} />}
        className='link'
        iconName='fa-solid fa-person-swimming'
        url={`freelancer/search?FreelanceUserId=${item.FreelancerUserId}`}
      />
    );
  }

  static generateDateFieldContent(item) {
    return dateTimeHelper.isIndefinite(item.EndDate) ? (
      <span>{dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.StartDate)} - &#8734;</span>
    ) : (
      <span className='densefont-1'>{`${dateTimeHelper.toYYYYsMMsDDWithIndefinite(
        item.StartDate
      )} - ${dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.EndDate)}`}</span>
    );
  }

  static editFunction(id, item, itemList) {
    //placeholder for a function from FreelancerFeeAdmin.js - Do not delete
  }

  static closeFunction(id, item, itemList) {
    //placeholder for a function from FreelancerFeeAdmin.js - Do not delete
  }

  static cloneThisFeeFunction(id, item, itemList) {
    //placeholder for a function from FreelancerFeeAdmin.js - Do not delete
  }

  static applyRules(item) {
    if (item.FeeType === FeeTypesEnum.DataQuality) {
      item.SelfAssigned = false;
      item.SurveyTypeCallsEmails = false;
    }
    if (item.FeeType === FeeTypesEnum.Resource) {
      item.OptFee = '';
    }

    return item;
  }

  static ConvertToJSON(item) {
    return {
      FreelancerUserId: parseInt(item.FreelancerUserId),
      FeeType: item.FeeType,
      ClientId: FreelancerFeeItem.ifNANThenZero(item.ClientId),
      SurveyId: FreelancerFeeItem.ifNANThenZero(item.SurveyId),
      TpSurveyId: FreelancerFeeItem.ifNANThenZero(item.TpSurveyId),
      WaveId: FreelancerFeeItem.ifNANThenZero(item.WaveId),
      TpWaveId: FreelancerFeeItem.ifNANThenZero(item.TpWaveId),
      CountryId: FreelancerFeeItem.ifNANThenZero(item.CountryId),
      StartDate: dateTimeHelper.toYYYYsMMsDD(item.StartDate),
      EndDate: dateTimeHelper.toYYYYsMMsDD(item.EndDate),
      Fee: parseFloat(item.Fee) >= 0 ? parseFloat(item.Fee) : null,
      OptFee: parseFloat(item.OptFee) >= 0 ? parseFloat(item.OptFee) : null,
      SelfAssigned: booleanHelper.toBoolean(item.SelfAssigned),
      SurveyTypeCallsEmails: booleanHelper.toBoolean(item.SurveyTypeCallsEmails),
      Tier: item.Tier,
      TimebasedSettlementEnabled: booleanHelper.toBoolean(item.TimebasedSettlementEnabled),
    };
  }

  static ifNANThenZero(num) {
    const conv = parseInt(num) > 0 ? parseInt(num) : 0;
    return isNaN(conv) ? 0 : conv;
  }

  static CorrectingTypes(item) {
    item.FreelancerFeeId = parseInt(item.FreelancerFeeId);
    item.FreelancerUserId = parseInt(item.FreelancerUserId);
    item.ClientId = FreelancerFeeItem.ifNANThenZero(item.ClientId);
    item.SurveyId = FreelancerFeeItem.ifNANThenZero(item.SurveyId);
    item.TpSurveyId = FreelancerFeeItem.ifNANThenZero(item.TpSurveyId);
    item.WaveId = FreelancerFeeItem.ifNANThenZero(item.WaveId);
    item.TpWaveId = FreelancerFeeItem.ifNANThenZero(item.TpWaveId);
    item.CountryId = FreelancerFeeItem.ifNANThenZero(item.CountryId);
    item.StartDate = dateTimeHelper.toYYYYsMMsDD(item.StartDate);
    item.EndDate = dateTimeHelper.toYYYYsMMsDD(item.EndDate);
    item.Fee = parseFloat(item.Fee) >= 0 ? parseFloat(item.Fee) : 0;
    item.OptFee = item.OptFee =
      parseFloat(item.OptFee) === -1 ? null : parseFloat(item.OptFee) >= 0 ? parseFloat(item.OptFee) : 0;
    item.SelfAssigned = booleanHelper.toBoolean(item.SelfAssigned);
    return item;
  }

  static getTierSelectOptions() {
    return [
      {
        label: 'Tier 1',
        value: 'tier1',
        disabled: false,
      },
      {
        label: 'Tier 2',
        value: 'tier2',
        disabled: false,
      },
      {
        label: 'Full Tier',
        value: 'fulltier',
        disabled: false,
      },
    ];
  }
}
